module.exports = __webpack_public_path__ + "img/Pic_ZHBG_BJ_d.01fa4e90.gif";